export default __webpack_public_path__ + "static/media/referral_banner.3d28e588.png";